import { BaseAction } from "./BaseAction";
export class VoidAction extends BaseAction {
    constructor(options = {}) {
        super(options);
    }
    static useDry() {
        new VoidAction();
    }
    triggerImplementation() { }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVm9pZEFjdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWIvYWN0aW9ucy9Wb2lkQWN0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBc0MsVUFBVSxFQUFFLE1BQU0sY0FBYyxDQUFDO0FBRTlFLE1BQU0sT0FBTyxVQUFXLFNBQVEsVUFBVTtJQUN4QyxZQUFtQixVQUF5QixFQUFFO1FBQzVDLEtBQUssQ0FBQyxPQUFPLENBQUMsQ0FBQztJQUNqQixDQUFDO0lBRU0sTUFBTSxDQUFDLE1BQU07UUFDbEIsSUFBSSxVQUFVLEVBQUUsQ0FBQztJQUNuQixDQUFDO0lBRVMscUJBQXFCLEtBQXlCLENBQUM7Q0FDMUQifQ==